// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2cf5ee37","453":"440258d4","732":"73eadec0","977":"3f9004b7"}[chunkId] + ".chunk.js";
};